var _style, _text, _text2, _text3, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFraseHeaderV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 273.1 91.9",
    style: {
      enableBackground: "new 0 0 273.1 91.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{font-family:'Poppins-Regular';}\n\t.st1{font-size:25.875px;}\n\t.st2{font-family:'Poppins-LightItalic';}\n\t.st3{font-size:28.5057px;}\n\t.st4{fill:#35A936;}\n\t.st5{font-family:'Poppins-Bold';}\n\t.st6{font-size:39.8479px;}\n\t.st7{fill:#95C45F;}\n\t.st8{font-family:'Poppins-SemiBold';}\n")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 88.1057 25.1981)",
    className: "st0 st1"
  }, "HIGH-QUALITY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 4.0267 81.7113)",
    className: "st2 st3"
  }, "Cleaning Solutions")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 3.955 56.9196)",
    className: "st4 st5 st6"
  }, "ECO")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 87.155 56.9196)",
    className: "st7 st8 st6"
  }, "FRIENDLY")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFraseHeaderV);
export default __webpack_public_path__ + "static/media/fraseHeaderV.838ee3dd7e25fef5300b0a90badbf7bb.svg";
export { ForwardRef as ReactComponent };